import {DummyProjectType} from "../entities/dummy/dummy-project-type.entity";
import {ProjectType} from "../entities/project-type.entity";
import {Repository} from "../../persistence/repository";
import {persistence} from "../../decorators/persistence.decorator";
import {singleton} from "tsyringe";

@singleton()
@persistence({
    entity: ProjectType,
    preload: true
})
export class ProjectTypeRepository extends Repository<ProjectType> {

    private _items = new Map<string, ProjectType | null>([
        [`default`, new ProjectType()]
    ]);

    private static _dummy = new DummyProjectType();

    public static get dummy(): DummyProjectType {
        return this._dummy;
    }

    public async findOneByKey(projectTypeKey: string): Promise<ProjectType> {
        if (!this._items.has(projectTypeKey)) {
            const projectType = await this.findOneBy(`key`, projectTypeKey) ?? null;
            this._items.set(projectTypeKey, projectType);
        }

        return this._items.get(projectTypeKey) ?? this._items.get(`default`)!;
    }

    public create(): Promise<ProjectType | null> {
        return Promise.resolve(new ProjectType());
    }
}
